import { FC, PropsWithChildren } from 'react';
import s from './profile-settings-label.module.css';

interface Props extends PropsWithChildren {
  label: string;
  subLabel: string;
}

export const ProfileSettingsLabel: FC<Props> = ({ label, subLabel, children }) => {
  return (
    <div className={s.feature}>
      <h3>{label}</h3>
      <h4>{subLabel}</h4>
      {children}
    </div>
  );
};
